import React from "react";

export default function ShippingPolicy() {
  return (
    <div className="container mx-auto p-6 max-w-4xl text-gray-800">
      <h1 className="text-3xl font-semibold mb-4">Shipping Policy</h1>
      <p className="mb-4">
        Our services are entirely digital and cloud-based. As such, no physical
        shipping or delivery of goods is involved.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">Service Activation</h2>
      <p className="mb-4">
        Upon successful payment, the organization’s account is activated
        automatically and access is provided to authorized users through secure
        login credentials.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">
        Access and Availability
      </h2>
      <p className="mb-4">
        The platform is accessible 24/7 from any supported device with internet
        connectivity. Maintenance windows, if required, will be notified in
        advance through email or system announcements.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">Support</h2>
      <p>
        For access-related issues or deployment assistance, please contact{" "}
        <a href="mailto:admin@cheritto.com" className="text-blue-600 underline">
          admin@cheritto.com
        </a>
        .
      </p>
    </div>
  );
}
